import styled from 'styled-components';
import logo from '@/main/assets/images/login/xnuup_main_logo_black.png';
import { Link } from 'react-router-dom';
import { Container as ContainerStepper } from '@/main/components/shared/stepper/styles';

const HEIGHT_BORDER_BOTTOM_STYLE = '40px';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  min-height: 200px;
  max-height: calc(100vh - 4rem - ${HEIGHT_BORDER_BOTTOM_STYLE});
  width: 960px;
  background: ${({ theme }) => theme.pantone656C};
  border-radius: 8px 8px 8px 0;
  padding: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 100%;
    max-width: 700px;
    max-height: calc(100vh - 2rem - ${HEIGHT_BORDER_BOTTOM_STYLE});
  }
`;

export const Logo = styled(Link)`
  background-image: url(${logo});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 40px;
  width: 100%;
  max-width: 120px;
  margin: 0 0 auto 0;
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  align-items: end;
  justify-content: center;
  width: 100%;

  ${ContainerStepper} {
    margin-left: auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: 0.5rem;

    ${ContainerStepper} {
      margin: 0 auto;
    }
  }
`;

export const AreaHeaderSteps = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 1.8rem 0 0 0;
  gap: 0.4rem;

  h4 {
    margin: 0;
    color: #000;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin: 0;
  }
`;

export const TitlePage = styled.h4``;

export const TitleStep = styled.h4`
  line-height: 0.9em;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  margin: 1.2rem 0 0;
  overflow: auto;
  padding: 0 0 0.4rem;
`;
export const Footer = styled.div`
  width: 100%;
`;

export const ContainerStyle = styled.div`
  position: absolute;
  height: ${HEIGHT_BORDER_BOTTOM_STYLE};
  width: 50%;
  background: ${({ theme }) => theme.pantone656C};
  left: 0;
  bottom: -39px;
  border-radius: 0 0 8px 8px;

  > svg {
    position: absolute;
    top: 0px;
    height: 40px;
    right: -23px;
    width: 34px;
    fill: ${({ theme }) => theme.pantone656C};
  }
`;

